// Polyfills
import "@babel/polyfill";
// import "lazysizes";

//Modules
import './modules/contactForm'
import './modules/team-toggle'
import './modules/navbar'
import './modules/faq'

// For project cover images add the loaded data attribute on load for styling utility
document.querySelectorAll('.project-image').forEach((element) => {
    element.addEventListener('load', () => {
        element.dataset.loaded = 'true';
    })
})